const pageSizeOptions = [
    {
        id: 1,
        optionLabel: '24',
        selectedLabel: 'Display: 24',
        hitsPerPage: 24,
        default: true,
    },
    { id: 2, optionLabel: '96', selectedLabel: 'Display: 96', hitsPerPage: 96 },
    {
        id: 3,
        optionLabel: '288',
        selectedLabel: 'Display: 288',
        hitsPerPage: 288,
    },
    {
        id: 4,
        optionLabel: '6',
        selectedLabel: '<span class="hidden-sm-down">Display: </span>6',
        hitsPerPage: 6,
        hidden: true,
    },
];

const getPageSizeDefault = () => pageSizeOptions.find(option => option.default);

const getOptionByHitsPerPage = hitsPerPage => {
    if (!hitsPerPage) return;
    return (
        pageSizeOptions.find(option => option.hitsPerPage === hitsPerPage) || {
            id: 5,
            optionLabel: hitsPerPage.toString(),
            selectedLabel: `Display: ${hitsPerPage}`,
            hitsPerPage,
        }
    );
};

export { pageSizeOptions, getPageSizeDefault, getOptionByHitsPerPage };
